document.addEventListener("change", (event) => {
	// #############################################################################
	// Planungsziel und Szenario einblenden bei Simulation
	// #############################################################################
	if (event.target.closest(".simulationsmodus_select")) {
		const formContainer = event.target.closest("form"),
			selectSimulationsmodus = event.target.closest(".simulationsmodus_select"),
			inputPlanungsziel = formContainer.querySelector(".planungsziel"),
			selectSzenario = formContainer.querySelector(".szenario")

		inputPlanungsziel.classList.add("hidden")
		if (selectSimulationsmodus.value != "linear") inputPlanungsziel.classList.remove("hidden")
		selectSzenario.classList.add("hidden")
		if (selectSimulationsmodus.value != "linear") selectSzenario.classList.remove("hidden")
	}
})
